import { ArrowUpIcon, ArrowDownIcon } from '@heroicons/react/24/outline';

interface SortToggleButtonProps {
  currentSortOrder: 'ASC' | 'DESC';
  onToggle: () => void;
}

/**
 * Presentational component for toggling story sort order.
 * Subtle, minimal design with no borders or focus rings.
 */
export const SortToggleButton = ({ currentSortOrder, onToggle }: SortToggleButtonProps) => {
  const isAscending = currentSortOrder === 'ASC';
  const Icon = isAscending ? ArrowDownIcon : ArrowUpIcon;
  const label = isAscending ? 'Oldest First' : 'Newest First';

  return (
    <button
      onClick={onToggle}
      aria-label={`Sort stories: ${label}`}
      className="inline-flex items-center gap-1.5 px-3 py-1.5 text-sm text-subtle hover:text-main transition-colors cursor-pointer outline-none"
    >
      <Icon className="w-4 h-4" />
      <span>{label}</span>
    </button>
  );
};
